import React, { useCallback, useState } from "react";
import { Box, Card, Table, Hidden, makeStyles } from "@material-ui/core";
import TableToolbar from "./TableToolbar";
import TableContent from "./TableContent";
import TableHeader from "./TableHeader";
import TableFooter from "./TableFooter";
import { stableSort, getComparator } from "../utils/SortList";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  "@keyframes fadeSlideUp": {
    "0%": { opacity: 0, transform: "translateY(14px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  root: {
    marginTop: "1.25rem",
    borderRadius: 16,
    boxShadow:
      "0 1px 4px rgba(0,0,0,0.04), 0 4px 20px rgba(0,0,0,0.07)",
    border: "1px solid rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    animation: "$fadeSlideUp 0.35s ease both",
  },
}));

const TableList = ({
  items = [],
  headCells = [],
  order: firstOrder,
  orderBy: firstOrderBy,
  rowsPerPage: firstRowsPerPage,
  addLabel = "",
  addAction = () => {},
  children,
  setSearchValue = () => {},
  add = true,
  onUpdateRowsAndPages = () => {},
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(firstRowsPerPage);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState(firstOrder);
  const [orderBy, setOrderBy] = useState(firstOrderBy);
  const handleLimitChange = useCallback(
    (event) => setRowsPerPage(event.target.value),
    [],
  );
  const handlePageChange = useCallback(
    (event, newPage) => setPage(newPage),
    [],
  );
  const handleRequestSort = useCallback(
    (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    },
    [orderBy, order],
  );

  const searchChange = useCallback(
    (value) => {
      setPage(0);
      setSearchValue(value);
    },
    [setSearchValue],
  );

  // useEffect(() => {
  //     onUpdateRowsAndPages(stableSort(items, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  // }, [page, rowsPerPage, order, orderBy])

  const onRefreshAction = useCallback(() => {
    onUpdateRowsAndPages(
      stableSort(items, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    );
  }, [onUpdateRowsAndPages, items, order, orderBy, page, rowsPerPage]);

  return (
    <Fragment>
      <TableToolbar
        searchLabel={t("table.search")}
        searchChange={(event) => searchChange(event.target.value)}
        addLabel={addLabel}
        addAction={addAction}
        add={add}
        refreshAction={onRefreshAction}
      />
      <Hidden xsDown>
        <Card className={classes.root}>
          <Box style={{ overflowX: "scroll" }} className="scrollbar">
            <Box minWidth={1050}>
              <Table>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  headCells={headCells}
                  onRequestSort={handleRequestSort}
                />
                <TableContent
                  items={items}
                  order={order}
                  orderBy={orderBy}
                  page={page}
                  rowsPerPage={rowsPerPage}
                >
                  {(item) => children(item)}
                </TableContent>
              </Table>
            </Box>
          </Box>
          <TableFooter
            count={items.length}
            handlePageChange={handlePageChange}
            handleLimitChange={handleLimitChange}
            rowsPerPage={rowsPerPage}
            page={page}
          />
        </Card>
      </Hidden>
      <Hidden smUp>
        {stableSort(items, getComparator(order, orderBy)).map((item) =>
          children(item),
        )}
      </Hidden>
    </Fragment>
  );
};

export default TableList;
